<p-toast></p-toast>
<div class="task-scheduler-page">
  <div class="page-header">
    <app-back-button
      [title]="'Task Scheduler' | translate"
      [ngStyle]="{ 'font-size': isSmallScreen ? '14px' : 'inherit' }"
      [parentRoute]="parentRoute"></app-back-button>
    <div class="page-header">
      <p class="page-subtitle">{{ "Manage automated security and maintenance tasks" | translate }}</p>
    </div>
  </div>
  @if (loading) {
    <div class="h-full w-full">
      <app-loading [loading]="loading"></app-loading>
    </div>
  } @else {
    <div class="page-content">
      <div class="flex justify-content-start mb-3">
        <button
          pButton
          type="button"
          [label]="'Add Task' | translate"
          icon="pi pi-plus"
          class="p-button-rounded add-button"
          (click)="addNewTask()"></button>
      </div>
      <p-tabs [(value)]="activeTab">
        <p-tablist>
          <p-tab value="0">{{ "Scheduled Tasks" | translate }}</p-tab>
          <p-tab value="1">{{ "Execution History" | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            <div class="scheduled-tasks-content">
              <p class="task-count">
                {{ getActiveTasksCount() }} {{ "of" | translate }} {{ scheduledTasks.length }}
                {{ "tasks enabled" | translate }}
              </p>
              <div class="search-section">
                <p-iconfield iconPosition="left">
                  <p-inputicon styleClass="pi pi-search"></p-inputicon>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearch()"
                    [placeholder]="'SEARCH' | translate"
                    class="search-input w-full"
                    [style.border-radius]="'12px'" />
                </p-iconfield>
              </div>
              <div class="task-cards-container">
                <div class="task-cards">
                  @for (task of filteredTasks; track task) {
                    <div
                      class="task-card"
                      [class.inactive]="!task.isActive"
                      [class.selected]="selectedTask?.id === task.id">
                      <div class="card-header">
                        <div>
                          <div
                            class="card-title-section"
                            (click)="selectTask(task)">
                            <div class="card-icon"></div>
                            <div>
                              <h3>{{ task.names?.[lang] }}</h3>
                            </div>
                          </div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 8px">
                          <p-toggleswitch
                            [(ngModel)]="task.isActive"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="updateTaskStatus(task, $event)"
                            (click)="$event.stopPropagation()"></p-toggleswitch>
                          <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-text p-button-sm delete-button"
                            (click)="deleteTask(task)"></button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (selectedTask) {
                  @if (loadingSystemBackgroundTask) {
                    <div
                      class="task-details"
                      [style.height]="'200px'">
                      <app-loading [loading]="loadingSystemBackgroundTask"></app-loading>
                    </div>
                  } @else {
                    @if (!currentSystemTask) {
                      <div class="task-details flex flex-row justify-content-center align-items-start">
                        <h3>{{ "No data found" | translate }}</h3>
                      </div>
                    } @else {
                      <div class="task-details">
                        <div class="details-header">
                          <h3>{{ currentSystemTask.names?.[lang] }}</h3>
                          <button
                            pButton
                            type="button"
                            [label]="'Edit Task' | translate"
                            icon="pi pi-pencil"
                            class="p-button-rounded add-button"
                            (click)="editTask(currentSystemTask); $event.stopPropagation()"></button>
                        </div>
                        <div class="details-info">
                          <div class="info-row">
                            <div class="info-item">
                              <span class="info-label">{{ "Status" | translate }}</span>
                              <div class="status-info">
                                <p-tag
                                  [value]="(currentSystemTask.isActive ? 'Active' : 'Inactive') | translate"
                                  [severity]="currentSystemTask.isActive ? 'success' : 'secondary'"></p-tag>
                                <span class="duration-text">
                                  {{ "Executions" | translate }} : {{ taskResultsTotal }} /{{
                                    currentSystemTask.maxExecutions === -1 ? "∞" : currentSystemTask.maxExecutions
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <app-data-table
                          class="task-history-table"
                          [data]="executionHistoryFiltered"
                          [totalRecords]="executionHistoryFiltered.length"
                          [columns]="tableColumns"></app-data-table>
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel value="1">
            <div class="history-content">
              <div class="history-header">
                <span class="history-title">{{ "Recent Task Executions" | translate }}</span>
              </div>
              @if (loadingHistory) {
                <div
                  class="flex justify-content-center align-items-center"
                  style="min-height: 200px">
                  <app-loading [loading]="loadingHistory"></app-loading>
                </div>
              } @else {
                <div class="history-cards">
                  @for (execution of paginatedExecutionHistory; track execution) {
                    <div
                      class="execution-card"
                      [class.error-card]="execution.status === 'failed'"
                      [class.selected]="selectedExecutionId === execution.id"
                      (click)="selectExecution(execution)">
                      <div
                        class="execution-icon"
                        [ngClass]="execution.status === 'failed' ? 'error-icon' : 'success-icon'">
                        @if (execution.status === "failed") {
                          <img
                            src="../../../../assets/icons/main/light/alert-line.svg"
                            alt="" />
                        } @else {
                          <img
                            src="../../../../assets/icons/main/light/check-double-fill.svg"
                            alt="" />
                        }
                      </div>

                      <div class="execution-details">
                        <h4>{{ execution.taskName?.[lang] }}</h4>
                        <div class="execution-meta">
                          <span class="execution-duration">
                            {{ "Duration" | translate }} : {{ execution.duration || "N/A" }}
                          </span>
                          <span class="execution-time">
                            {{ "Time" | translate }} : {{ execution.createdAt | date: "medium" }}
                          </span>
                        </div>
                      </div>

                      <p-tag
                        [value]="taskSchedulerService.getResultStatusName(execution.resultType) | translate"
                        [severity]="execution.status === 'success' ? 'success' : 'danger'"></p-tag>
                    </div>
                  }
                </div>
                <app-custom-paginator
                  [first]="historyFirst"
                  [pageSize]="historyRows"
                  [totalRecords]="historyTotalRecords"
                  [rowsPerPageOptions]="[10, 25, 50, 100]"
                  (pageChange)="onHistoryPageChange($event)"
                  (pageSizeChange)="onHistoryPageSizeChange($event)"></app-custom-paginator>
              }
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  }
</div>

<ng-template
  #statusTemplate
  let-row>
  <i
    class="pi"
    [ngClass]="{
      'pi-check-circle text-green-500': row.resultType === 0,
      'pi-times-circle text-red-500': row.resultType !== 0,
    }"
    style="font-size: 1.2rem"></i>
</ng-template>

<ng-template
  #errorsTemplate
  let-row>
  @if (row.hasErrors) {
    <span class="text-red-500">{{ row.errorMessages }}</span>
  } @else {
    <span>-</span>
  }
</ng-template>
